
import React, { createContext, useContext } from 'react';
import { WaterDashboardContextType } from './types';
import { useDashboardState } from './useDashboardState';

// Create the context with undefined as initial value
const WaterDashboardContext = createContext<WaterDashboardContextType | undefined>(undefined);

/**
 * Provider component that wraps the application (or part of it)
 * to provide water dashboard state and functions
 */
export const WaterDashboardProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Get all dashboard state and functions from our custom hook
  const dashboardState = useDashboardState();

  return (
    <WaterDashboardContext.Provider value={dashboardState}>
      {children}
    </WaterDashboardContext.Provider>
  );
};

/**
 * Custom hook to use the water dashboard context
 * This ensures type safety and proper error handling when the context is used
 */
export const useWaterDashboard = () => {
  const context = useContext(WaterDashboardContext);
  if (context === undefined) {
    throw new Error('useWaterDashboard must be used within a WaterDashboardProvider');
  }
  return context;
};

// Re-export types for convenience
export type { KpiCardType } from './types';
